import { PHONE, locationSchema } from "../structured-data-core";

export function getLasVegasStructuredData() {
  const url = "https://restorehair.com/locations/nevada/las-vegas/";
  const description =
    "Find out about your hair transplant options in Las Vegas with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Las Vegas", "871 Coronado Center Drive, Suite 200", "Henderson", "NV", PHONE, url, description),
  ];
}
